import React, { useEffect, useState } from "react";
import { PlayCircleOutlined, PauseOutlined } from "@ant-design/icons";
import { message, Popover } from "antd";
import SystemApi from "../../../api/sys";
import flvjs from "flv.js";
import "./index.scss";

const { monitorUrl } = window.globalConfig;

export default () => {
  const [channelList, setChannelList] = useState([]);
  const [videoCount, setVideoCount] = useState(4);
  const [flvPlayerObj, setFlvPlayerObj] = useState({});

  useEffect(() => {
    getChannelList();
    return () => {
      for (let attr in flvPlayerObj) {
        flvPlayerObj[attr] && flvPlayerObj[attr].destroy();
      }
    };
  }, []);

  const getChannelList = () => {
    SystemApi.getDeviceChannelList({}).then((res) => {
      if (res.status !== "0") return;
      res.data &&
        res.data.map((item) => {
          item.isPlay = false;
        });
      setChannelList(res.data ?? []);
    });
  };

  const play = (index, { id }) => {
    SystemApi.getDevicePreviewUrl({ id }).then((res) => {
      if (res.status !== "0") return;
      if (flvjs.isSupported) {
        const videoElement = document.getElementById(`videoSurveillance${id}`);
        const flvPlayer = flvjs.createPlayer({
          type: "flv",
          url: `${monitorUrl}playRtsp?url=${res.data.url}`,
        });
        flvPlayer.attachMediaElement(videoElement);
        flvPlayer.load();
        videoElement.play();

        flvPlayerObj[`flvPlayer${id}`] = flvPlayer;
        setFlvPlayerObj(flvPlayerObj);

        channelList[index].isPlay = true;
        setChannelList(() => [...channelList]);
      } else {
        message.error("FLV not supported");
      }
    });
  };

  const pause = (index, id) => {
    flvPlayerObj[`flvPlayer${id}`] && flvPlayerObj[`flvPlayer${id}`].destroy();
    flvPlayerObj[`flvPlayer${id}`] = null;
    channelList[index].isPlay = false;
    setChannelList(() => [...channelList]);
  };

  const countEle = () => {
    return (
      <div className="v-c-w">
        <div className="v-b v-b-1" onClick={() => setVideoCount(1)}></div>
        <div className="v-b v-b-2" onClick={() => setVideoCount(2)}>
          {Array.from({ length: 4 }).map((item, index) => (
            <div key={index}></div>
          ))}
        </div>
        <div className="v-b v-b-3" onClick={() => setVideoCount(3)}>
          {Array.from({ length: 9 }).map((item, index) => (
            <div key={index}></div>
          ))}
        </div>
        <div className="v-b v-b-4" onClick={() => setVideoCount(4)}>
          {Array.from({ length: 16 }).map((item, index) => (
            <div key={index}></div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="video-surveillance">
      <div className="v-aside">
        <h2>通道列表</h2>
        <ul className="channel-list">
          {channelList.map((item, index) => (
            <li key={item.id}>
              <div className="title">{item.name}</div>
              <div className="modify">
                <div className="play">
                  {item.isPlay ? (
                    <PauseOutlined onClick={() => pause(index, item.id)} />
                  ) : (
                    <PlayCircleOutlined
                      title="开始播放"
                      onClick={() => play(index, item)}
                    />
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="v-content">
        <div className="v-list">
          {channelList.map((item) => {
            return (
              <div
                className="v-list-item"
                key={item.id}
                style={{
                  width: `calc(100% / ${videoCount})`,
                  height: `calc(100% / ${videoCount})`,
                }}
              >
                <video
                  controls={item.isPlay}
                  id={`videoSurveillance${item.id}`}
                ></video>
              </div>
            );
          })}
        </div>
        <div className="v-controls">
          <Popover placement="left" title="" content={countEle} color="#343434">
            <div className="video-show-count">
              <div className={"v-b v-b-" + videoCount}>
                {Array.from({
                  length:
                    videoCount == 1
                      ? 0
                      : videoCount == 2
                      ? 4
                      : videoCount == 3
                      ? 9
                      : 16,
                }).map((item, index) => (
                  <div key={index}></div>
                ))}
              </div>
            </div>
          </Popover>
        </div>
      </div>
    </div>
  );
};
